module.exports = __webpack_public_path__ + "static/media/jenni.7d237eca.jpg";